import { render, staticRenderFns } from "./UnidadImportacion.vue?vue&type=template&id=17686cec&scoped=true"
import script from "./UnidadImportacion.vue?vue&type=script&lang=js"
export * from "./UnidadImportacion.vue?vue&type=script&lang=js"
import style0 from "./UnidadImportacion.vue?vue&type=style&index=0&id=17686cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17686cec",
  null
  
)

export default component.exports